import CheckMark from 'components/utils/icons/CheckMark';
import { setBodyBusy } from 'helpers/uiHelpers';
import CircledCheck from 'icons/CircledCheck';
import React, {
	useEffect, useReducer
} from 'react';
import MailCheck from 'react-mailcheck';
import {
	animated,Transition
} from 'react-spring';

import {
	BottomWrapper,
	Button,
	Checkbox,
	CheckWrapper,
	CircleCheckWrapper,
	SectionWrapper,
} from './styles';

const reducer = (prevState, newState) => (
	{
		...prevState,
		...newState,
	}
);

const Signup = ({
	setSection, activeSection, section, token, scrollToSection, setPatient, patient,
}) => {
	const [state, setState] = useReducer(reducer,
		{
			email: '',
			password: '',
			firstname: '',
			lastname: '',
			newsletter: true,
			errorValue: false,
			submitted: false,
			loading: false,
			existing_user: false,
			blank: false,
		});

	// Handles the logged in patient case
	useEffect(() => {
		if (Object.keys(patient).length !== 0) {
			setState({
				...{
					submitted: true,
					email: patient.email,
				},
			});
		}
	},
	[patient]);

	const handleChange = (e) => {
		const {
			name, value,
		} = e.target;
		const tempState = {};
		tempState[name] = value;
		setState({ ...tempState });
	};

	const replaceEmail = (suggestion) => {
		setState({ ...{ email: suggestion } });
	};

	const handleCheck = () => {
		setState({
			newsletter: !state.newsletter,
		});
	};

	// Only for guest checkout
	const handleEdit = () => {
		setSection(section);
		setState({
			submitted: false,
		});
	}

	async function signout() {
		setState({ ...{ errorValue: '' } });
		if (!state.loading) {
			setBodyBusy(true);
			setState({ ...{ loading: true } });

			if (!token) {
				console.error('No token available');
				setState({ errorValue: 'Oops, we\'re current experiencing technical difficulties. Please try again. If the issue persists, please contact care@apostrophe.com. Thank you.' });
				return
			}

			try {
				const res = await fetch('/ajax/signout/',
					{
						method: 'POST',
						body: JSON.stringify({}),
						contentType: 'application/json',
						dataType: 'json',
						headers: {
							'X-CSRFToken': token,
						},
					});
				const {
					error, response,
				} = await res.json();
				if (error) {
					throw new Error(error);
				}
				// Refresh the page now that we are logged out
				window.location = '/yd/register/order-otcs/?otc_type=AP_SCREEN';
			} catch (error) {
				console.error(`We have an error: ${error}`);
				setState({
					...{
						loading: false,
						errorValue: error.toString(),
					},
				});
				setBodyBusy(false);
			}
		}
	}

	async function submitForm() {
		setState({ ...{ errorValue: '' } });
		if (!state.loading) {
			if (state.firstname === '' || state.lastname === '' || state.email === '' || state.password === '') {
				setState({
					...{
						errorValue: 'Please fill out all fields',
						blank: true,
					},
				});
			} else if (!state.email.includes('@') || !state.email.includes('.')) {
				setState({ ...{ errorValue: 'Please enter a valid email' } });
			} else {
				setBodyBusy(true);
				setState({ ...{ loading: true } });

				if (!token) {
					console.error('No token available');
					setState({ errorValue: 'Oops, we\'re current experiencing technical difficulties. Please try again. If the issue persists, please contact care@apostrophe.com. Thank you.' });
					return
				}

				try {
					const formdata = {
						'basic.email': state.email,
						'basic.password': state.password,
						firstname: state.firstname,
						lastname: state.lastname,
						campaign: 'sunscreen',
					}
					if (!state.newsletter) {
						formdata.disable_marketing = true;
					}
					const res = await fetch('/ajax/signup/',
						{
							method: 'POST',
							body: JSON.stringify(formdata),
							contentType: 'application/json',
							dataType: 'json',
							headers: {
								'X-CSRFToken': token,
							},
						});
					const {
						error, response,
					} = await res.json();
					if (error) {
						throw new Error(error);
					}
					if (response && response.basic && response.basic.registrationStep === 'COMPLETE') {
						// Redirect to existing patient skin checkout page
						//#TODO Check if current url has query param and use the otc_type from that instead of hardcoding for 'Screen
						window.location = '/yd/patient/order/?otc_type=AP_SCREEN';
					} else {
						let is_exisiting = response && response.is_existing_user ? true : false
						setState({
							...{
								submitted: true,
								loading: false,
								existing_user: is_exisiting,
							},
						});
						setSection(section + 1);
						setBodyBusy(false);
						scrollToSection('shipping');
						setPatient(response.basic);
					}
				} catch (error) {
					console.error(`We have an error: ${error}`);
					if (error.toString().includes('account already exists')) {
						setState({
							...{
								loading: false,
								errorValue: 'It looks like you already have an account! Please try your password again.',
							},
						});
					} else {
						setState({
							...{
								loading: false,
								errorValue: error.toString(),
							},
						});
					}
					setBodyBusy(false);
				}
			}
		}
	}

	return (
		<MailCheck email={state.email}>
			{(suggestion) => (
				<SectionWrapper activeSection={activeSection} section={section} guest={state.guest} submitted={state.submitted}>
					<h5 onClick={handleEdit}>EDIT</h5>
					<h3>1 of 3</h3>
					<h1>{(state.existing_user || Object.keys(patient).length !== 0) ? 'Logged in' : state.submitted ? 'Created Account' : 'Create Account'} {state.submitted && <CircleCheckWrapper><CircledCheck /></CircleCheckWrapper>}</h1>
					{state.submitted && <h2>{state.email}</h2>}
					{state.submitted && <a className="logout" onClick={signout}>Logout</a>}
					<Transition
						items={activeSection === section}
						from={{
							opacity: 0,
							height: 0,
						}}
						enter={{
							opacity: 1,
							height: state.errorValue ? 480 : 430,
						}}
						leave={{
							opacity: 0,
							height: 0,
						}}
					>
						{(styles, item) => item && <animated.div key={item} style={state.errorValue ? {
							height: 'auto',
							opacity: 1,
						} : styles}>
							<div className="content">
								<h2>Already have an account? <a href="/login/screen/" >Login</a></h2>
								<div className="form-group no-guest">
									<input tabIndex="10" onChange={handleChange} id="firstname" type="text" name="firstname" required/>
									<label htmlFor="firstname">First Name</label>
								</div>
								<div className="form-group no-guest">
									<input tabIndex="20" onChange={handleChange} id="lastname" type="text" name="lastname" required/>
									<label value={state.lastname} htmlFor="lastname">Last Name</label>
								</div>
								<div className="form-group">
									<input tabIndex="30" onChange={handleChange} id="email" type="text" name="email" value={state.email} required/>
									<label htmlFor="email">Email</label>
								</div>
								{suggestion
                  && <h2 className="error" onClick={() => replaceEmail(suggestion.full)} style={{ cursor: 'pointer' }}>Did you mean <span style={{ textDecoration: 'underline' }}>{suggestion.full}</span>?</h2>
								}
								<div className="form-group no-guest">
									<input tabIndex="40" onChange={handleChange} id="password" type="password" name="password" value={state.password} required/>
									<label htmlFor="password">Password</label>
								</div>
								<CheckWrapper className="no-guest">
									<input type="checkbox" name="newsletter" id="newsletter"/>
									<Checkbox checked={state.newsletter} onClick={handleCheck}>
										<CheckMark />
									</Checkbox>
									<label htmlFor="newsletter" onClick={handleCheck}>Yes, my inbox could use some Apostrophe love!</label>
								</CheckWrapper>
								{state.errorValue
                  && <h2 className="error" style={{ cursor: 'pointer' }}>{state.errorValue}</h2>
								}
								<BottomWrapper>
									<Button onClick={submitForm}>
                    Save & continue
									</Button>
									{/* <h4 className="no-guest" onClick={() => setState({ guest: true })}>Checkout as guest</h4> */}
								</BottomWrapper>
							</div>
						</animated.div>}
					</Transition>
				</SectionWrapper>
			)}
		</MailCheck>
	);
};

export default Signup;
